import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
const highlights = ['6 volumes complets', '150 cours prêts à enseigner', '5 bonus professionnels', 'Contenu entièrement visuel', 'Accès immédiat'];
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-16 pt-14 sm:pb-24 sm:pt-20" data-id="element-137" data-mp="129h2ttccdag2">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[620px] bg-brand-blush" data-id="element-138" data-mp="127ec173d7daa" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-139" data-mp="x8b7rov7lb3d">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-140" data-mp="s9giq56neqat">
          <p className="mb-5 font-display text-xl font-semibold text-brand-ink sm:text-2xl" data-id="element-141" data-mp="3d2bn1yjw7fzr">
            <ProductName data-id="element-142" data-mp="381nw1cvnyz5j" />
          </p>
          <h1 className="mx-auto max-w-4xl text-4xl font-semibold leading-[1.08] text-brand-ink sm:text-5xl lg:text-6xl" data-id="element-143" data-mp="384s4img5wh20">
            Préparez une année entière de cours de danse classique{' '}
            <span className="italic text-brand-deep" data-id="element-144" data-mp="3o59dnnvztegn">
              en seulement 5 minutes.
            </span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 w-full sm:mt-10" data-id="element-145" data-mp="3e8mqgsg72bbg">
          <img src="https://cdn.magicpatterns.com/uploads/kcA2mqdf9vHnW8m2vmg8zX/Diseno_sin_titulo_(65).png" alt="Professeur de Danse Classique Pro : coffret des 6 volumes, tablette Trouveur de cours et les 5 guides bonus" className="mx-auto w-full max-w-2xl drop-shadow-xl" data-id="element-146" data-mp="35audvw1uxhrr" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7" data-id="element-147" data-mp="2ll0f2y0q62e1">
          <p className="mx-auto max-w-2xl text-base leading-7 text-brand-muted sm:text-lg" data-id="element-148" data-mp="najgjljwi9dy">
            150 cours prêts à enseigner, progressions techniques, exercices,
            corrections, évaluations et outils pédagogiques pour professeurs de
            danse classique.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base font-medium leading-7 text-brand-ink sm:text-lg" data-id="element-149" data-mp="1azulzgc74ryf">
            Le système professionnel 6-en-1, entièrement visuel, prêt à
            consulter et à utiliser directement avec vos élèves.
          </p>
          <div className="mt-8" data-id="element-150" data-mp="x14mxv5tgi7f">
            <CheckoutButton data-id="element-151" data-mp="x02zssbj059c">ACCÉDEZ AU SYSTÈME COMPLET MAINTENANT</CheckoutButton>
          </div>
          <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-3 text-sm font-medium text-brand-muted" data-id="element-152" data-mp="3lt73mli5bhrm">
            {highlights.map(item => <li key={item} className="flex items-center gap-2" data-id="element-153" data-mp="1x9kwertfdeju">
                <CheckCircle2Icon size={17} className="text-brand-gold" aria-hidden="true" data-id="element-154" data-mp="1x784pmxv7ptl" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}